import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

export function usePopoverOpenClose() {
  const location = useLocation();

  const [key, setKey] = useState(uuidv4());
  const [isOpen, _setIsOpen] = useState(false);

  const setIsOpen = (value: boolean) => {
    _setIsOpen(value);
    setKey(uuidv4());
  };

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return {
    isOpen,
    setIsOpen,
    key,
  };
}
